const schoolData = [
  {
    logoUrl: "https://admin.locallive.tv/public/logos/2677.jpg",
    schoolName: "Granada Hills Charter",
    city: "Granada Hills",
    state: "CA",
    conference: null,
    slug: "granada-hills-charter",
    id: 2677,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/2406.jpg",
    schoolName: "The Harker School",
    city: "San Jose",
    state: "CA",
    conference: null,
    slug: "harker-school",
    id: 2406,
  },
  {
    logoUrl: null,
    schoolName: "The Thacher School",
    city: "Ojai",
    state: "CA",
    conference: "Big North Conference (NJ)",
    slug: "thacher-school",
    id: 1,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/107.jpg",
    schoolName: "Brunswick School",
    city: "Greenwich",
    state: "CT",
    conference: "New England Preparatory School Athletic Council",
    slug: "brunswick",
    id: 107,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/54.jpg",
    schoolName: "Canterbury School",
    city: "New Milford",
    state: "CT",
    conference: "New England Preparatory School Athletic Council",
    slug: "canterbury",
    id: 54,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/56.jpg",
    schoolName: "Choate Rosemary Hall",
    city: "Wallingford",
    state: "CT",
    conference: "New England Preparatory School Athletic Council",
    slug: "choate-rosemary",
    id: 56,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/631.jpg",
    schoolName: "Ellington High School",
    city: "Ellington",
    state: "CT",
    conference: "Big North Conference (NJ)",
    slug: "ellingtonct",
    id: 631,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/57.jpg",
    schoolName: "The Ethel Walker School",
    city: "Simsbury",
    state: "CT",
    conference: "New England Preparatory School Athletic Council",
    slug: "ethel-walker",
    id: 57,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/388.jpg",
    schoolName: "Fairfield Warde High School",
    city: "Fairfield",
    state: "CT",
    conference: "Fairfield County Interscholastic Athletic Conference",
    slug: "fairfield-warde",
    id: 388,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/62.jpg",
    schoolName: "Kent School",
    city: "Kent",
    state: "CT",
    conference: "New England Preparatory School Athletic Council",
    slug: "kent-school",
    id: 62,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/67.jpg",
    schoolName: "Pomfret School",
    city: "Pomfret",
    state: "CT",
    conference: "New England Preparatory School Athletic Council",
    slug: "pomfret",
    id: 67,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/735.jpg",
    schoolName: "Sacred Heart Greenwich",
    city: "Greenwich",
    state: "CT",
    conference: "New England Preparatory School Athletic Council",
    slug: "sacred-heart-greenwich",
    id: 735,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/555.jpg",
    schoolName: "Stamford High School",
    city: "Stamford",
    state: "CT",
    conference: "Fairfield County Interscholastic Athletic Conference",
    slug: "stamfordhighschool",
    id: 555,
  },
  {
    logoUrl: "https://admin.locallive.tv/logos/60.jpg",
    schoolName: "The Hotchkiss School",
    city: "Lakeville",
    state: "CT",
    conference: "New England Preparatory School Athletic Council",
    slug: "hotchkiss",
    id: 60,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/2401.jpg",
    schoolName: "West Haven High School",
    city: "West Haven",
    state: "CT",
    conference: "Big North Conference (NJ)",
    slug: "w-haven-hs",
    id: 2401,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/560.jpg",
    schoolName: "Westhill High School",
    city: "Stamford",
    state: "CT",
    conference: "Fairfield County Interscholastic Athletic Conference",
    slug: "westhill-hs",
    id: 560,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/2449.jpg",
    schoolName: "Atlanta International School",
    city: "Atlanta",
    state: "GA",
    conference: "Georgia High School Athletic Association",
    slug: "atlanta-internationa",
    id: 2449,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1025.jpg",
    schoolName: "Rabun Gap-Nacoochee School",
    city: "Rabun Gap",
    state: "GA",
    conference: "North Carolina Independent Schools Athletic Association",
    slug: "rgns",
    id: 1025,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/783.jpg",
    schoolName: "Savannah Country Day School",
    city: "Savannah",
    state: "GA",
    conference: "Georgia High School Athletic Association",
    slug: "savannahcountryday",
    id: 783,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/784.jpg",
    schoolName: "The Avery Coonley School",
    city: "Downers Grove",
    state: "IL",
    conference: null,
    slug: "averycoonley",
    id: 784,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1341.jpg",
    schoolName: "Culver Academies",
    city: "Culver",
    state: "IN",
    conference: "New England Preparatory School Athletic Council",
    slug: "culver-acad",
    id: 1341,
  },
  {
    logoUrl: null,
    schoolName: "Austin Preparatory School",
    city: "Reading",
    state: "MA",
    conference: "Catholic Central League",
    slug: "austin-prep",
    id: 1993,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/219.jpg",
    schoolName: "Deerfield Academy",
    city: "Deerfield",
    state: "MA",
    conference: "New England Preparatory School Athletic Council",
    slug: "deerfieldacademy",
    id: 219,
  },
  {
    logoUrl: "https://admin.locallive.tv/logos/1376.png",
    schoolName: "Eaglebrook School",
    city: "Deerfield",
    state: "MA",
    conference: "New England Preparatory School Athletic Council",
    slug: "eaglebrook",
    id: 1376,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1248.jpg",
    schoolName: "Groton School",
    city: "Groton",
    state: "MA",
    conference: "New England Preparatory School Athletic Council",
    slug: "groton-school",
    id: 1248,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/248.jpg",
    schoolName: "Northfield Mount Hermon",
    city: "Gill",
    state: "MA",
    conference: "New England Preparatory School Athletic Council",
    slug: "nmh",
    id: 248,
  },
  {
    logoUrl: null,
    schoolName: "St. Mary's High School",
    city: "Lynn",
    state: "MA",
    conference: "Catholic Central League",
    slug: "st-marys-ma",
    id: 2062,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1900.jpg",
    schoolName: "Ursuline Academy",
    city: "Dedham",
    state: "MA",
    conference: "Big North Conference (NJ)",
    slug: "ursuline-acad-mass",
    id: 1900,
  },
  {
    logoUrl: "https://admin.locallive.tv/logos/1387.jpg",
    schoolName: "Wilbraham & Monson Academy",
    city: "Wilbraham",
    state: "MA",
    conference: "New England Preparatory School Athletic Council",
    slug: "wilbraham-monson-aca",
    id: 1387,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/2524.jpg",
    schoolName: "Hebron Academy",
    city: "Hebron",
    state: "ME",
    conference: "New England Preparatory School Athletic Council",
    slug: "hebron-acad",
    id: 2524,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1426.jpg",
    schoolName: "Friends School of Baltimore",
    city: "Baltimore",
    state: "MD",
    conference: "Maryland Interscholastic Athletic Association",
    slug: "friends-baltimore",
    id: 1426,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/2311.jpg",
    schoolName: "Maryvale Preparatory School",
    city: "Lutherville",
    state: "MD",
    conference: null,
    slug: "maryvale",
    id: 2311,
  },
  {
    logoUrl: "https://admin.locallive.tv/logos/524.jpg",
    schoolName: "St. Mary's School and Parish",
    city: "Annapolis",
    state: "MD",
    conference: "Maryland Interscholastic Athletic Association",
    slug: "st-marys-hs",
    id: 524,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/115.jpg",
    schoolName: "Stone Ridge School of the Sacred Heart",
    city: "Bethesda",
    state: "MD",
    conference: "Independent School League (DC area)",
    slug: "stone-ridge",
    id: 115,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/2480.jpg",
    schoolName: "Oakhill Day School",
    city: "Gladstone",
    state: "MO",
    conference: null,
    slug: "oakhill-day-school",
    id: 2480,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1369.jpg",
    schoolName: "St. Andrew's Episcopal School",
    city: "Ridgeland",
    state: "MS",
    conference: "Big North Conference (NJ)",
    slug: "standrewsms",
    id: 1369,
  },
  {
    logoUrl: "https://admin.locallive.tv/logos/1096.png",
    schoolName: "Asheville School",
    city: "Asheville",
    state: "NC",
    conference: "North Carolina Independent Schools Athletic Association",
    slug: "ashevilleschool",
    id: 1096,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/633.jpg",
    schoolName: "Cannon School",
    city: "Concord",
    state: "NC",
    conference: "North Carolina Independent Schools Athletic Association",
    slug: "cannonschool",
    id: 633,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1407.jpg",
    schoolName: "Christ School",
    city: "Arden",
    state: "NC",
    conference: "North Carolina Independent Schools Athletic Association",
    slug: "christ-school",
    id: 1407,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1150.jpg",
    schoolName: "Metrolina Christian Academy",
    city: "Indian Trail",
    state: "NC",
    conference: "North Carolina Independent Schools Athletic Association",
    slug: "metrolina-christian",
    id: 1150,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/774.jpg",
    schoolName: "Phillips Exeter Academy",
    city: "Exeter",
    state: "NH",
    conference: "New England Preparatory School Athletic Council",
    slug: "phillips-exeter-acad",
    id: 774,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/4.png",
    schoolName: "Bergen Catholic High School",
    city: "Oradell",
    state: "NJ",
    conference: "Big North Conference (NJ)",
    slug: "bergen-catholic",
    id: 4,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/25.jpg",
    schoolName: "Blair Academy",
    city: "Blairstown",
    state: "NJ",
    conference: "Mid-Atlantic Prep League",
    slug: "blair",
    id: 25,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/3487.jpg",
    schoolName: "Christina Seix Academy",
    city: "Trenton",
    state: "NJ",
    conference: null,
    slug: "christina-seix-acad",
    id: 3487,
  },
  {
    logoUrl: "https://admin.locallive.tv/logos/6.png",
    schoolName: "The Lawrenceville School",
    city: "Lawrenceville",
    state: "NJ",
    conference: "Mid-Atlantic Prep League",
    slug: "lawrencevilleschool",
    id: 6,
  },
  {
    logoUrl: "https://admin.locallive.tv/logos/27.png",
    schoolName: "The Peddie School",
    city: "Hightstown",
    state: "NJ",
    conference: "Mid-Atlantic Prep League",
    slug: "peddie-school",
    id: 27,
  },
  {
    logoUrl: "https://admin.locallive.tv/logos/28.jpg",
    schoolName: "The Pennington School",
    city: "Pennington",
    state: "NJ",
    conference: "Mid-Atlantic Prep League",
    slug: "pennington",
    id: 28,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/748.jpg",
    schoolName: "Archbishop Stepinac High School",
    city: "White Plains",
    state: "NY",
    conference: "Catholic High School Athletic Association",
    slug: "stepinac",
    id: 748,
  },
  {
    logoUrl: "https://admin.locallive.tv/logos/889.png",
    schoolName: "Ardsley High School",
    city: "Ardsley",
    state: "NY",
    conference: "NYSPHSAA",
    slug: "ardsley-hs",
    id: 889,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/798.jpg",
    schoolName: "Arlington High School",
    city: "Lagrangeville",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "arlington-hs-ny",
    id: 798,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/792.jpg",
    schoolName: "Brewster CSD",
    city: "Brewster",
    state: "NY",
    conference: "Big North Conference (NJ)",
    slug: "brewster-hs",
    id: 792,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/881.jpg",
    schoolName: "Briarcliff High School",
    city: "Briarcliff Manor",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "briarcliff-hs",
    id: 881,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/3381.jpg",
    schoolName: "Bronx Prep High School",
    city: "Bronx",
    state: "NY",
    conference: "Big North Conference (NJ)",
    slug: "bronx-prep-hs-ny",
    id: 3381,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/307.jpg",
    schoolName: "Bronxville High School",
    city: "Bronxville",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "bronxville-hs",
    id: 307,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/803.jpg",
    schoolName: "Byram Hills High School",
    city: "Armonk",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "byram-hills-hs",
    id: 803,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/749.jpg",
    schoolName: "Cardinal Hayes High School",
    city: "Bronx",
    state: "NY",
    conference: "Catholic High School Athletic Association",
    slug: "cardinal-hayes-hs",
    id: 749,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/766.jpg",
    schoolName: "Carmel High School",
    city: "Carmel Hamlet",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "carmel-hs-ny",
    id: 766,
  },
  {
    logoUrl: "https://admin.locallive.tv/logos/721.jpg",
    schoolName: "Chaminade High School",
    city: "Mineola",
    state: "NY",
    conference: "Catholic High School Athletic Association",
    slug: "chaminade",
    id: 721,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/2280.jpg",
    schoolName: "Charter School of Educational Excellence (CSEE)",
    city: "Yonkers",
    state: "NY",
    conference: "Catholic High School Athletic Conference (NY)",
    slug: "charterschoolofeducationalexcellence",
    id: 2280,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/969.jpg",
    schoolName: "Clarkstown High School North",
    city: "New City",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "clarkstownnyn",
    id: 969,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1001.jpg",
    schoolName: "Clarkstown High School South",
    city: "West Nyack",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "clarkstownnys",
    id: 1001,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/821.jpg",
    schoolName: "Cornwall Central High School",
    city: "New Windsor",
    state: "NY",
    conference: "Big North Conference (NJ)",
    slug: "cornwall-central-hs",
    id: 821,
  },
  {
    logoUrl: "https://admin.locallive.tv/logos/742.jpg",
    schoolName: "Dalton School",
    city: "New York",
    state: "NY",
    conference: "Big North Conference (NJ)",
    slug: "dalton-school",
    id: 742,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1565.jpg",
    schoolName: "Depew High School",
    city: "Depew",
    state: "NY",
    conference: "Erie County Interscholastic Conference",
    slug: "depew-hs",
    id: 1565,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/894.jpg",
    schoolName: "Dobbs Ferry High School",
    city: "Dobbs Ferry",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "dobbs-ferry-hs",
    id: 894,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/857.jpg",
    schoolName: "Eastchester High School",
    city: "Eastchester",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "eastchester-hs",
    id: 857,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/760.jpg",
    schoolName: "Fordham Preparatory School",
    city: "Bronx",
    state: "NY",
    conference: "Catholic High School Athletic Association",
    slug: "fordham-preparatory",
    id: 760,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/796.jpg",
    schoolName: "Fox Lane High School",
    city: "Bedford",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "foxlane",
    id: 796,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/3205.jpg",
    schoolName: "Greenburgh-North Castle UFSD",
    city: "Dobbs Ferry",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "greenburgh-n-castle",
    id: 3205,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/305.jpg",
    schoolName: "Hackley School",
    city: "Tarrytown",
    state: "NY",
    conference: null,
    slug: "hackley",
    id: 305,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/855.jpg",
    schoolName: "Harrison High School",
    city: "Harrison",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "harrison-hs-ny",
    id: 855,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1243.jpg",
    schoolName: "Hastings High School",
    city: "Hastings-On-Hudson",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "hastings-hs",
    id: 1243,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/779.jpg",
    schoolName: "Hendrick Hudson High School",
    city: "Montrose",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "hendrick-hudson-hs",
    id: 779,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/732.jpg",
    schoolName: "School of the Holy Child",
    city: "Rye",
    state: "NY",
    conference: "New England Preparatory School Athletic Council",
    slug: "holy-child",
    id: 732,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/780.jpg",
    schoolName: "Horace Greeley High School",
    city: "Chappaqua",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "horace-greeley-hs",
    id: 780,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/533.jpg",
    schoolName: "Horace Mann School",
    city: "Bronx",
    state: "NY",
    conference: null,
    slug: "horace-mann",
    id: 533,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/306.jpg",
    schoolName: "Iona Preparatory School",
    city: "New Rochelle",
    state: "NY",
    conference: "Catholic High School Athletic Association",
    slug: "ionaprep",
    id: 306,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1168.jpg",
    schoolName: "Irvington High School",
    city: "Irvington",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "irvington-hs-ny",
    id: 1168,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/765.jpg",
    schoolName: "John Jay Cross River High School",
    city: "Cross River",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "john-jay-hs",
    id: 765,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/893.jpg",
    schoolName: "John Jay - East Fishkill High School",
    city: "Hopewell Junction",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "john-jay-east-fish",
    id: 893,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/737.jpg",
    schoolName: "Kennedy Catholic Prep",
    city: "Somers",
    state: "NY",
    conference: "Catholic High School Athletic Association",
    slug: "jfkcatholicny",
    id: 737,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/704.jpg",
    schoolName: "Lakeland High School",
    city: "Shrub Oak",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "lakelandhigh",
    id: 704,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1502.jpg",
    schoolName: "Lancaster High School",
    city: "Lancaster",
    state: "NY",
    conference: "Erie County Interscholastic Conference",
    slug: "lancaster-csd",
    id: 1502,
  },
  {
    logoUrl: "https://admin.locallive.tv/logos/2690.png",
    schoolName: "Liberty High School",
    city: "Liberty",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "liberty-hs-ny",
    id: 2690,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1282.jpg",
    schoolName: "Long Island Lutheran Middle & High School",
    city: "Glen Head",
    state: "NY",
    conference: null,
    slug: "longislandlutheran",
    id: 1282,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/781.jpg",
    schoolName: "Mahopac High School",
    city: "Mahopac",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "mahopacny",
    id: 781,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/820.jpg",
    schoolName: "Mamaroneck High School",
    city: "Mamaroneck",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "mamaroneck-hs",
    id: 820,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/830.jpg",
    schoolName: "Maria Regina High School",
    city: "Hartsdale",
    state: "NY",
    conference: "Catholic High School Athletic Conference (NY)",
    slug: "maria-regina-hs",
    id: 830,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/40.jpg",
    schoolName: "The Masters School",
    city: "Dobbs Ferry",
    state: "NY",
    conference: "New England Preparatory School Athletic Council",
    slug: "masters-school-ny",
    id: 40,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/3776.jpg",
    schoolName: "Magen David Yeshivah",
    city: "Brooklyn",
    state: "NY",
    conference: null,
    slug: "magen-david-yeshivah",
    id: 3776,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1203.jpg",
    schoolName: "Monroe-Woodbury CSD",
    city: "Central Valley",
    state: "NY",
    conference: null,
    slug: "monroe-woodbury-hs",
    id: 1203,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/346.jpg",
    schoolName: "Monsignor Farrell High School",
    city: "Staten Island",
    state: "NY",
    conference: "Catholic High School Athletic Conference (NY)",
    slug: "monsignor-farrell-hs",
    id: 346,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1274.jpg",
    schoolName: "Moore Catholic High School",
    city: "Staten Island",
    state: "NY",
    conference: "Catholic High School Athletic Association",
    slug: "moore-cath-hs",
    id: 1274,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/952.jpg",
    schoolName: "Mount Vernon High School",
    city: "Mt. Vernon",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "mt-vernon-hs",
    id: 952,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/823.jpg",
    schoolName: "Nazareth Regional High School",
    city: "Brooklyn",
    state: "NY",
    conference: "Catholic High School Athletic Association",
    slug: "nazareth-regional-hs",
    id: 823,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/867.jpg",
    schoolName: "North Rockland High School",
    city: "Thiells",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "north-rockland-hs",
    id: 867,
  },
  {
    logoUrl: "https://admin.locallive.tv/logos/1091.jpg",
    schoolName: "North Salem High School",
    city: "North Salem",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "north-salem-csd",
    id: 1091,
  },
  {
    logoUrl: "https://admin.locallive.tv/logos/794.png",
    schoolName: "Ossining High School",
    city: "Ossining",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "ossining-hs",
    id: 794,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/778.jpg",
    schoolName: "Peekskill High School",
    city: "Peekskill",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "peekskillny",
    id: 778,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/775.jpg",
    schoolName: "Pleasantville High School",
    city: "Pleasantville",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "pleasantville-hs",
    id: 775,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/739.jpg",
    schoolName: "Poly Prep Country Day School",
    city: "Brooklyn",
    state: "NY",
    conference: null,
    slug: "polyprep",
    id: 739,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1005.jpg",
    schoolName: "Port Chester High School",
    city: "Port Chester",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "port-chester-hs",
    id: 1005,
  },
  {
    logoUrl: "https://admin.locallive.tv/logos/3268.jpg",
    schoolName: "Ramaz School",
    city: "New York",
    state: "NY",
    conference: "Big North Conference (NJ)",
    slug: "ramaz-ny",
    id: 3268,
  },
  {
    logoUrl: null,
    schoolName: "Reformed Church of Bronxville RCB",
    city: "Bronxville",
    state: "NY",
    conference: "Big North Conference (NJ)",
    slug: "reformed-church-bron",
    id: 3850,
  },
  {
    logoUrl: "https://admin.locallive.tv/logos/880.jpg",
    schoolName: "Roy C Ketcham Senior High School",
    city: "Wappingers Falls",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "ketcham-senior-hs",
    id: 880,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/241.jpg",
    schoolName: "Rye Country Day School",
    city: "Rye",
    state: "NY",
    conference: "New England Preparatory School Athletic Council",
    slug: "rcds",
    id: 241,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/309.jpg",
    schoolName: "Rye High School",
    city: "Rye",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "rye-hs",
    id: 309,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1429.jpg",
    schoolName: "Rye Neck Senior High School",
    city: "Mamaroneck",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "rye-neck-hs",
    id: 1429,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/531.jpg",
    schoolName: "Salesian High School",
    city: "New Rochelle",
    state: "NY",
    conference: "Catholic High School Athletic Association",
    slug: "salesian",
    id: 531,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/3269.jpg",
    schoolName: "SAR High School",
    city: "The Bronx",
    state: "NY",
    conference: "Big North Conference (NJ)",
    slug: "sar-ny",
    id: 3269,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/736.jpg",
    schoolName: "Sleepy Hollow High School",
    city: "Sleepy Hollow",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "sleepy-hollow-hs",
    id: 736,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/776.jpg",
    schoolName: "Somers High School",
    city: "Lincolndale",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "somersny",
    id: 776,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/754.jpg",
    schoolName: "St. Dominic High School",
    city: "Oyster Bay",
    state: "NY",
    conference: "Catholic High School Athletic Association",
    slug: "stdoms",
    id: 754,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/767.jpg",
    schoolName: "St. Joseph by the Sea High School",
    city: "Staten Island",
    state: "NY",
    conference: "Catholic High School Athletic Association",
    slug: "st-joseph-sea",
    id: 767,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/769.jpg",
    schoolName: "St. Peter's Boys High School",
    city: "Staten Island",
    state: "NY",
    conference: "Catholic High School Athletic Association",
    slug: "st-peters-ny",
    id: 769,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/983.jpg",
    schoolName: "Suffern High School",
    city: "Suffern",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "suffern-hs",
    id: 983,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/786.jpg",
    schoolName: "Tappan Zee High School",
    city: "Orangeburg",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "tappan-zee-hs",
    id: 786,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/312.png",
    schoolName: "The Ursuline School",
    city: "New Rochelle",
    state: "NY",
    conference: "Catholic High School Athletic Conference (NY)",
    slug: "ursulineschool",
    id: 312,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/891.jpg",
    schoolName: "Tuckahoe High School",
    city: "Eastchester",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "tuckahoeny",
    id: 891,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1848.jpg",
    schoolName: "United Nations International School (UNIS)",
    city: "New York",
    state: "NY",
    conference: "Big North Conference (NJ)",
    slug: "united-nations-inter",
    id: 1848,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/705.jpg",
    schoolName: "Walter Panas High School",
    city: "Cortlandt",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "walterpanas",
    id: 705,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1491.jpg",
    schoolName: "West Seneca HS - East",
    city: "West Seneca",
    state: "NY",
    conference: "Erie County Interscholastic Conference",
    slug: "west-seneca-east",
    id: 1491,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/2054.jpg",
    schoolName: "West Seneca HS - West",
    city: "Buffalo",
    state: "NY",
    conference: "Erie County Interscholastic Conference",
    slug: "west-seneca-hs-west",
    id: 2054,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1003.jpg",
    schoolName: "White Plains High School",
    city: "White Plains",
    state: "NY",
    conference: "NYSPHSAA - Section 1",
    slug: "white-plains-hs",
    id: 1003,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/763.jpg",
    schoolName: "Xaverian High School",
    city: "Brooklyn",
    state: "NY",
    conference: "Catholic High School Athletic Association",
    slug: "xaverianhs",
    id: 763,
  },
  {
    logoUrl: "https://admin.locallive.tv/logos/2.jpg",
    schoolName: "The Hill School",
    city: "Pottstown",
    state: "PA",
    conference: "Mid-Atlantic Prep League",
    slug: "hill-school",
    id: 2,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1626.jpg",
    schoolName: "La Salle College High School",
    city: "Wyndmoor",
    state: "PA",
    conference: null,
    slug: "la-salle-clg-hs",
    id: 1626,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/91.jpg",
    schoolName: "Westtown School",
    city: "West Chester",
    state: "PA",
    conference: null,
    slug: "westtownschool",
    id: 91,
  },
  {
    logoUrl: "https://admin.locallive.tv/logos/1172.gif",
    schoolName: "Christ Church Episcopal School",
    city: "Greenville",
    state: "SC",
    conference: null,
    slug: "christ-church-episc",
    id: 1172,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1549.jpg",
    schoolName: "Battle Ground Academy",
    city: "Franklin",
    state: "TN",
    conference: "Tennessee Secondary School Athletic Association",
    slug: "battle-ground-acad",
    id: 1549,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/126.jpg",
    schoolName: "Brentwood Academy",
    city: "Brentwood",
    state: "TN",
    conference: "Tennessee Secondary School Athletic Association",
    slug: "brentwood",
    id: 126,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/133.jpg",
    schoolName: "Father Ryan High School",
    city: "Nashville",
    state: "TN",
    conference: "Tennessee Secondary School Athletic Association",
    slug: "father-ryan",
    id: 133,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/1161.jpg",
    schoolName: "Harpeth Hall School",
    city: "Nashville",
    state: "TN",
    conference: null,
    slug: "harpethhall",
    id: 1161,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/11.jpg",
    schoolName: "McCallie School",
    city: "Chattanooga",
    state: "TN",
    conference: "Tennessee Secondary School Athletic Association",
    slug: "mccallieschool",
    id: 11,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/299.png",
    schoolName: "Montgomery Bell Academy",
    city: "Nashville",
    state: "TN",
    conference: "Tennessee Secondary School Athletic Association",
    slug: "montgomery-bell",
    id: 299,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/643.jpg",
    schoolName: "All Saints Episcopal School",
    city: "Tyler",
    state: "TX",
    conference: "Texas Association of Private and Parochial Schools",
    slug: "all-saints",
    id: 643,
  },
  {
    logoUrl: "https://admin.locallive.tv/public/logos/16.jpg",
    schoolName: "Episcopal High School - VA",
    city: "Alexandria",
    state: "VA",
    conference: "Independent School League (DC area)",
    slug: "episcopalhighschool",
    id: 16,
  },
];

export default schoolData;
